import type { Preloadable } from "@/components/types"
import { type ComponentType, lazy } from "react"

type LazyLoadFactory<T> = () => Promise<{ default: T }>

// biome-ignore lint/suspicious/noExplicitAny: OnPurpose
const ReactLazyPreload = <T extends ComponentType<any>>(
  importStatement: LazyLoadFactory<T>,
): Preloadable<T> => {
  const Component = lazy(importStatement) as unknown as T & {
    preload: () => void
  }

  Component.preload = importStatement

  return Component
}

export default ReactLazyPreload
